import React, { ReactElement, ReactNode } from "react";
import { Navigate } from "react-router-dom";


type ProtectedRouteProps={
    element:ReactElement;
};

//Protected Route Component
const ProtectedRoute=({element}:ProtectedRouteProps)=>{
    const isAuthenticated=localStorage.getItem("isAuthenticated")==="true";
    return isAuthenticated ? element :<Navigate to="/"/>
};

export default ProtectedRoute;